module.exports = __webpack_public_path__ + "static/media/yourPhoto.d8f8c31c.svg";